import * as React from "react";

import useChatMessageLimits from "@agent-ui/features/chat/hooks/useChatMessageLimits";
import useCurrentProjectId from "@v2/hooks/useCurrentProjectId";
import { X } from "lucide-react";
import { Link } from "react-router-dom";

// eslint-disable-next-line replo/prefer-props-with-children -- cloneElement requires JSX.Element (Patrick, 2026-03-02)
const MessageLimitWrapper = ({ children }: { children: React.JSX.Element }) => {
  const projectId = useCurrentProjectId();
  const { messagesRemaining, hasUnlimitedMessages } = useChatMessageLimits();

  const [isDismissed, setIsDismissed] = React.useState(false);

  const shouldShowLimitBanner = !hasUnlimitedMessages;

  const canDismissBanner = !hasUnlimitedMessages && messagesRemaining > 0;

  const showBanner =
    shouldShowLimitBanner && !(canDismissBanner && isDismissed);

  if (!showBanner) {
    return children;
  } else {
    return (
      <div
        className="flex flex-col items-center justify-center p-0.5 rounded-[10px]"
        style={{
          background:
            "linear-gradient(90deg, rgba(0, 0, 0, 0.10) -84.44%, rgba(233, 25, 108, 0.10) 100%)",
        }}
      >
        {React.cloneElement(children, {
          isMessageLimitShowing: true,
        })}
        <div className="flex justify-between items-center w-full px-2.5 py-2">
          <span className="text-sm">
            {messagesRemaining <= 0
              ? "You've used all your messages"
              : `${messagesRemaining} messages remaining`}
          </span>
          <div className="flex items-center gap-1.5">
            <Link
              to={`/shops/${projectId}/settings/workspace/billing`}
              className="text-pink hover:underline text-sm"
            >
              Get more
            </Link>
            {canDismissBanner && (
              <button
                onClick={() => setIsDismissed(true)}
                className="hover:text-pink"
              >
                <X className="size-3.5" />
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }
};

export default MessageLimitWrapper;
